module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-86ff9c47.png";